import { setSessionStorage } from "../../../shared/utils/sessionStorage";
import { ANALYTICS_STORAGE_KEYS, LINK_INFO } from "../../../shared/constants/analytics";

export const updateUrl = (episodeContentId, episodeExternalId, isRecordingPlayer) => {
  const currentHash = window.location.hash;
  const updatedHash = currentHash.replace(
    currentHash.substring(currentHash.indexOf("?"), currentHash.length),
    `?playbackId=${episodeContentId}${isRecordingPlayer ? `&externalId=${episodeExternalId}` : ""}&contentType=${
      isRecordingPlayer ? "RECORDING" : "VOD"
    }`
  );
  window.history.replaceState({}, currentHash, updatedHash);
};

export const setAnalyticsLink = (itemRowNumber) => {
  if (typeof itemRowNumber === "number") {
    setSessionStorage(ANALYTICS_STORAGE_KEYS.LINK, `${itemRowNumber + 1};${LINK_INFO.EPISODE_SIDEBAR}`);
  }
};

export const loadProgramDetails = (
  dispatch,
  appProvider,
  episodeContentId,
  isRecordingPlayer,
  contentType,
  loadRecordingProgramDetail,
  loadProgramDetail
) => {
  if (isRecordingPlayer) {
    dispatch(loadRecordingProgramDetail(appProvider, episodeContentId.toString(), contentType));
  } else {
    dispatch(loadProgramDetail(appProvider, episodeContentId.toString(), "vod"));
  }
};

export const handleProgramChange = (
  playNextEpisodeCallback,
  onSwitchProgramEndSessionRef,
  trackMediaEnd,
  resetPlayerAttributes,
  isDynatraceTrackingEnabled
) => {
  if (playNextEpisodeCallback) {
    // change content from `skipToNextEpisode`, `playNextEpisode` or `autoPlay`
    playNextEpisodeCallback();
  } else if (onSwitchProgramEndSessionRef.current) {
    // change content from sidebar
    onSwitchProgramEndSessionRef.current.onSwitchProgramEndConvivaSession();
    trackMediaEnd(null, isDynatraceTrackingEnabled);
  }
  resetPlayerAttributes(isDynatraceTrackingEnabled);
};
